angular.module('qkr').directive('outletsmap', (utils) => {
    // Directive link function
    const link = function(scope, element, attrs) {
        let map, infoWindow;
        const markers = [];
        const markerBounds = [];
        const defaultZoom = 14;
        const geocoder = new google.maps.Geocoder();
        // Map config
        const mapOptions = {
            zoom: 10,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false
        };

        // Init the map
        function initMap() {
            if (map === void 0) {
                map = new google.maps.Map(element[0], mapOptions);
            }
        }

        // Place a marker
        function setMarker(map, position, title, content) {
            let marker;
            const markerOptions = {
                position,
                map,
                title,
                icon: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
            };

            marker = new google.maps.Marker(markerOptions);
            markers.push(marker); // Add marker to array

            google.maps.event.addListener(marker, 'click', () => {
                // Close window if not undefined
                if (infoWindow !== void 0) {
                    infoWindow.close();
                }
                // Create new window
                const infoWindowOptions = {
                    content,
                    position: marker.position
                };
                infoWindow = new google.maps.InfoWindow(infoWindowOptions);
                infoWindow.open(map, marker);
            });
        }

        
        function placeMarkers() {
        	const bounds = new google.maps.LatLngBounds();
        	markerBounds.push(bounds);
            scope.outlets
                .filter(outlet => outlet.contactDetails && outlet.latitude && outlet.longitude)
                .forEach(outlet => {
                	const addressArray = [];
                	if (!utils.hasNoValue(outlet.contactDetails.addressLine1)) {
                		addressArray.push(outlet.contactDetails.addressLine1);
                	}

                	if (!utils.hasNoValue(outlet.contactDetails.addressLine2)) {
                		addressArray.push(outlet.contactDetails.addressLine2);
                	}

                	if (!utils.hasNoValue(outlet.contactDetails.city)) {
                		addressArray.push(outlet.contactDetails.city);
                	}

                	const outletAddressContent = addressArray.join(', ');

                    const outletLatLong = new google.maps.LatLng(outlet.latitude, outlet.longitude);
                    setMarker(map, outletLatLong, outlet.name, outletAddressContent);
                    bounds.extend(outletLatLong);

            });

            google.maps.event.addListenerOnce(map, 'bounds_changed', function(event) {
            	if (this.getZoom() > defaultZoom) {
            		this.setZoom(defaultZoom);
            	}
            });

            map.fitBounds(bounds);
        }
        function resetMarkerBounds() {
            angular.forEach(markerBounds, (bounds) => {
                map.fitBounds(bounds);
            });

            if (map.getZoom() > defaultZoom) {
                map.setZoom(defaultZoom);
            }
        }
        function clearMarkers() {
        	for (let i = 0; i < markers.length; i++) {
        		markers[i].setMap(null);
        	}
        	markers.length = 0;
        }

        function resetCountryBounds(country) {
            if (country !== null && map) {
                if (!utils.hasNoValue(country) && utils.hasNoValue(scope.outlets)) {
                    geocoder.geocode({address: country.name}, (results, status) => {
                        if (utils.hasNoValue(scope.outlets) && status == google.maps.GeocoderStatus.OK) {
                            map.setCenter(results[0].geometry.location);
                            map.fitBounds(results[0].geometry.bounds);
                        }
                    });
                }
            }
        }
        scope.$watchCollection('outlets', (newVal) => {
        	clearMarkers();
        	if (!utils.hasNoValue(newVal) && map) {
        		placeMarkers();
        	}
        });
        
        scope.$watch('country', (country) => {
            resetCountryBounds(country);
        });
        scope.$watch('visible', (visible) => {
            if (visible) {
                initMap();
                placeMarkers();
                resetMarkerBounds();
                resetCountryBounds(scope.country);
            }
        });
    };

    return {
        restrict: 'A',
        scope: {
        	outlets: '=',
        	country: '=',
            visible: '='
        },
        template: '<div id="gmaps" style="height: 400px; width: 100%"></div>',
        replace: true,
        link
    };
});



// WEBPACK FOOTER //
// ./src/directives/maps/outlets.js